import FaceSwap from './FaceSwap';
export default FaceSwap;